import { showFromFade, throttle, loadLibrary } from "../../js/Util";
import { LIB_URL } from '../../js/App';

if ($(".advantages-slider-wrap").length) {
    // window.scrollTo(0, 0);
    // window.scrollTo({top: 0, behavior: });
    $("html, body").animate({ scrollTop: 0 }, 100);
}

$('.js-advantages-slider').each((i, sliderDom) => {
    loadLibrary(LIB_URL.SWIPER, () => {
        const advantagesSlider = new Swiper(sliderDom, {
            slidesPerView: "auto",
            spaceBetween: 16,
            slidesOffsetAfter: 30,
            navigation: {
                nextEl: ".advantages-next",
                prevEl: ".advantages-prev",
            },
            breakpoints: {
                1441: {
                    slidesOffsetAfter: 210,
                    spaceBetween: 20,
                },
            },
        });
    });
});

$('.js-advantages-slider-reverse').each((i, sliderDom) => {
    loadLibrary(LIB_URL.SWIPER, () => {
        let colSlides = $(".js-advantages-slider-reverse").find(".swiper-slide").length;
        const advantagesSliderReverse = new Swiper(sliderDom, {
            slidesPerView: "auto",
            spaceBetween: 16,
            initialSlide: colSlides,
            navigation: {
                nextEl: ".advantages-next-reverse",
                prevEl: ".advantages-prev-reverse",
            },
            breakpoints: {
                1441: {
                    spaceBetween: 20,
                },
            },
        });
    });
});

let position = App.W.scrollTop();

function throttleScroll() {
    let scroll = App.W.scrollTop();

    if (scroll > 10) {
        $(".section-wrap").addClass("_active-wrap-1");
        $(".section-wrap").addClass("_active-wrap-2");
        $(".section-wrap").removeClass("_hide-sections");
    } else {
        $(".section-wrap").removeClass("_active-wrap-1");
        $(".section-wrap").addClass("_hide-sections");
    }

    if (scroll < position && scroll < 500) {
        $(".section-wrap").removeClass("_active-wrap-2");
    }

    if (scroll > 10) {
        $(".section-wrap").addClass("_animate-wrap-2");
    } else {
        $(".section-wrap").removeClass("_animate-wrap-2");
    }

    position = scroll;
}

if (App.W.width() >= 1100) {
    App.W.on("scroll", (position) => {
        throttle(throttleScroll(position), 50);
    });
}

if ($(".available-tile:not(.available-tile-adv)").length) {
    $(".available-tile:not(.available-tile-adv)").each((index, item) => {
        const start =
            $(document).width() >= 768 ? "top bottom-=20%" : "top bottom-=10%";
        showFromFade(item, start);
    });
}
